import { useTieneRol } from "@/lib/sesion";
import { TutorialCalidad } from "./TutorialCalidad";
import { TutorialExternos } from "./TutorialExternos";

const ROLES_CALIDAD = ["GERENTE_CALIDAD", "AUXILIAR_CALIDAD", "ADMIN_SICEN"];

/**
 * Página de ayuda contextual del módulo Trámites Legales. Detecta el rol del
 * usuario y muestra el tutorial correspondiente: Calidad ve la guía operativa
 * de captura; externos (Tramitador, Titular, Gestor, Representante) ven la
 * guía de "qué preparar y qué pasa después".
 */
export function AyudaRegistroLegalPage() {
  // Identidad efectiva: bajo suplantación el tutorial debe ser el que le toca
  // al usuario suplantado, no el del administrador.
  const esCalidad = useTieneRol(...ROLES_CALIDAD);

  return esCalidad ? <TutorialCalidad /> : <TutorialExternos />;
}
